import React from 'react';
import { Container, Row } from 'reactstrap';
// import { Redirect } from 'react-router-dom';
import CustomersLists from './components/CustomersLists';

const Customers = () => {
  const userdata = JSON.parse(localStorage.getItem('userData'));
  if (['1', '5'].indexOf(userdata.type) === -1) { // not admin
    // return (<Redirect to="/dashboard" />);
    console.log('');
  }

  return (
    <Container>
      <Row>
        <CustomersLists />
      </Row>
    </Container>
  );
};

export default Customers;
